var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.4C0.668629 4.4 0.4 4.66863 0.4 5C0.4 5.33137 0.668629 5.6 1 5.6V4.4ZM9.42426 5.42426C9.65858 5.18995 9.65858 4.81005 9.42426 4.57574L5.60589 0.757359C5.37157 0.523045 4.99167 0.523045 4.75736 0.757359C4.52304 0.991674 4.52304 1.37157 4.75736 1.60589L8.15147 5L4.75736 8.39411C4.52304 8.62843 4.52304 9.00833 4.75736 9.24264C4.99167 9.47696 5.37157 9.47696 5.60589 9.24264L9.42426 5.42426ZM1 5.6H9V4.4H1V5.6Z",
    fill: "#EB612C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeArrow);
export default __webpack_public_path__ + "static/media/orange_arrow.d984558fa1f4e5a2b00e7218ae25c001.svg";
export { ForwardRef as ReactComponent };